import * as tslib_1 from "tslib";
import * as React from 'react';
import CreateButton from 'src/components/CreateButton';
import SurveyApi from 'src/services/SurveyApi';
var TaskSurvey = /** @class */ (function (_super) {
    tslib_1.__extends(TaskSurvey, _super);
    function TaskSurvey(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            surveyLink: ''
        };
        _this.handleSurvey = function () {
            window.open(_this.state.surveyLink);
        };
        return _this;
    }
    TaskSurvey.prototype.componentWillMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var surveyLink;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, SurveyApi.get(this.props.task.competencyId)];
                    case 1:
                        surveyLink = _a.sent();
                        this.setState({ surveyLink: surveyLink });
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskSurvey.prototype.render = function () {
        if (!this.state.surveyLink) {
            return null;
        }
        return (React.createElement(CreateButton, { onClick: this.handleSurvey }, "K\u00E9rd\u0151\u00EDv kit\u00F6lt\u00E9se"));
    };
    return TaskSurvey;
}(React.Component));
export default TaskSurvey;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskSurvey.tsx
// module id = 744
// module chunks = 0